import { RouterModule, Routes } from '@angular/router';
import { UserTrackingComponent } from './pages/user-tracking/user-tracking.component';
import { NoDataFoundComponent } from './shared/components/no-data-found/no-data-found.component';

export const routes: Routes = [
  {
    path: 'user-tracking/:id',
    component: UserTrackingComponent
  },
  { path: '**', pathMatch: 'full', component: NoDataFoundComponent }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});
